import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';

const ServicesDropdown = () => {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    if (open) document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  const sections = [
    {
      title: 'Vos Abonnements Numériques',
      items: [
        { label: 'Découvrir nos formules', sub: 'Stockage, audio, restauration incluse', path: '/offres', testId: 'svc-abonnements' },
      ],
    },
    {
      title: 'Restauration IA',
      items: [
        { label: 'Restauration Renaissance', sub: 'À l\'unité (0,99€) ou en pack (7,99€)', path: '/services', testId: 'svc-restauration' },
      ],
    },
    {
      title: 'Numérisation de Souvenirs',
      items: [
        { label: 'Kits de Numérisation', sub: 'L\'Écrin · Le Coffret · La Malle — Service physique', path: '/numerisation', testId: 'svc-numerisation' },
      ],
    },
    {
      title: 'La Boutique de Prestige',
      items: [
        { label: 'Nos Livres d\'Art', sub: 'L\'Essentiel, La Chronique, Le Grand Récit', path: '/livre-photo', testId: 'svc-livres-art' },
      ],
    },
  ];

  const go = (path) => {
    setOpen(false);
    navigate(path);
  };

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button
        onClick={() => setOpen(!open)}
        data-testid="services-dropdown-toggle"
        style={{
          fontFamily: "'Georgia', serif", fontSize: 12, letterSpacing: 0.5,
          backgroundColor: 'transparent', color: '#D4AF37',
          border: '1px solid rgba(212,175,55,0.4)',
          padding: '6px 14px', borderRadius: 6, cursor: 'pointer',
          display: 'flex', alignItems: 'center', gap: 6,
          transition: 'all 0.3s',
        }}
        onMouseEnter={e => { e.currentTarget.style.backgroundColor = 'rgba(212,175,55,0.1)'; e.currentTarget.style.borderColor = '#D4AF37'; }}
        onMouseLeave={e => { if (!open) { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.borderColor = 'rgba(212,175,55,0.4)'; } }}
      >
        {t('dash_prestige')}
        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#D4AF37" strokeWidth="2.5"
          style={{ transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }}>
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </button>

      {open && (
        <div
          data-testid="services-dropdown-menu"
          style={{
            position: 'absolute', top: 'calc(100% + 8px)', right: 0, zIndex: 100,
            backgroundColor: '#0a0a0a',
            border: '1px solid rgba(212,175,55,0.2)',
            borderRadius: 12, overflow: 'hidden',
            boxShadow: '0 12px 40px rgba(0,0,0,0.7), 0 0 1px rgba(212,175,55,0.2)',
            minWidth: 300, maxWidth: 'calc(100vw - 24px)',
            animation: 'fadeInDown 0.2s ease-out',
          }}
        >
          {sections.map((section, si) => (
            <div key={si}>
              {si > 0 && <div style={{ height: 1, backgroundColor: 'rgba(212,175,55,0.15)', margin: '0 16px' }} />}
              <div style={{ padding: '14px 16px 4px' }}>
                <span style={{
                  fontFamily: "'Georgia', serif", fontSize: 10, fontWeight: 600,
                  color: '#D4AF37', letterSpacing: 1.5, textTransform: 'uppercase',
                }}>
                  {section.title}
                </span>
              </div>
              {section.items.map((item) => (
                <button
                  key={item.testId}
                  data-testid={item.testId}
                  onClick={() => go(item.path)}
                  style={{
                    width: '100%', textAlign: 'left', display: 'block',
                    background: 'none', border: 'none',
                    padding: '10px 16px', cursor: 'pointer',
                    transition: 'background 0.2s',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.background = 'rgba(212,175,55,0.06)'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = 'none'; }}
                >
                  <span style={{
                    fontFamily: "'Georgia', serif", fontSize: 13, color: '#D4AF37',
                    display: 'block', lineHeight: 1.3,
                  }}>
                    {item.label}
                  </span>
                  <span style={{
                    fontFamily: "'Georgia', serif", fontSize: 11,
                    color: '#FAF3E0', display: 'block', marginTop: 2,
                  }}>
                    {item.sub}
                  </span>
                </button>
              ))}
            </div>
          ))}
        </div>
      )}

      <style>{`
        @keyframes fadeInDown {
          from { opacity: 0; transform: translateY(-6px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default ServicesDropdown;
